(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-offer-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kj-offer-slider')) {
  customElements.define('kj-offer-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.ko-track');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prev = this.querySelector('.ko-prev');
      this.next = this.querySelector('.ko-next');
      this.classList.add('ko-ready');
      this.track.scrollLeft = 0;
      const move = direction => {
        const card = this.track.querySelector('.ko-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * (rtl ? -1 : 1) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        if (this.prev) this.prev.disabled = position < 2;
        if (this.next) this.next.disabled = position >= end - 2;
      };
      this.prev?.addEventListener('click', () => move(-1), options);
      this.next?.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive:true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || matchMedia('(max-width:749px)').matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      window.addEventListener('pageshow', () => { this.track.scrollLeft = 0; update(); }, options);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.classList.remove('ko-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-gallery')) {
    customElements.define('silver-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.sgController) return;
        this.sgController = new AbortController();
        const options = { signal: this.sgController.signal };
        this.sgDialog = this.querySelector('dialog');
        if (!this.sgDialog || typeof this.sgDialog.showModal !== 'function') return;
        this.sgOpener = this.querySelector('.sg-open');
        this.classList.add('sg-ready');
        this.sgOpener.addEventListener('click', () => {
          if (this.sgDialog.open) return;
          this.sgDialog.showModal();
          this.sgOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.sgLocked = true;
        }, options);
        this.querySelector('.sg-close').addEventListener('click', () => this.sgDialog.close(), options);
        this.sgDialog.addEventListener('click', event => {
          if (event.target !== this.sgDialog) return;
          const rect = this.sgDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.sgDialog.close();
        }, options);
        this.sgDialog.addEventListener('close', () => {
          this.sgUnlock();
          if (this.sgOpener.getClientRects().length) this.sgOpener.focus({ preventScroll: true });
        }, options);
        this.sgMedia = window.matchMedia('(min-width: 750px)');
        this.sgMedia.addEventListener('change', event => {
          if (event.matches && this.sgDialog.open) this.sgDialog.close();
        }, options);
      }
      sgUnlock() {
        if (!this.sgLocked) return;
        document.documentElement.style.overflow = this.sgOverflow;
        this.sgLocked = false;
      }
      disconnectedCallback() {
        this.sgController?.abort();
        if (this.sgDialog?.open) this.sgDialog.close();
        this.sgUnlock();
        this.sgController = null;
        this.classList.remove('sg-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
